import React, { useState } from 'react';
import classname from 'classnames';
import styles from './Features.module.scss';
import PaymentsTab from './PaymentsTab';
import EventsTab from './EventsTab';
import BounceHelmet from '../../util/Helmet/Helmet';
import SocialTab from './SocialTab';
import ButtonPill from '../../util/ButtonPill/ButtonPill';

const Features = () => {
  const tabs = [
    { title: 'Events', tabName: <EventsTab /> },
    { title: 'Payments', tabName: <PaymentsTab /> },
    { title: 'Social', tabName: <SocialTab /> }
  ];

  function TabGroup() {
    const [active, setActive] = useState(tabs[0].tabName);

    return (
      <div style={{ margin: 0 }}>
        <div className={styles.MenuBackground}>
          <nav className={styles.Menu}>
            {tabs.map((tab) => (
              <button
                className={classname(styles.Tab, {
                  [styles.active]: active === tab.tabName
                })}
                key={tab.title}
                onClick={() => setActive(tab.tabName)}
              >
                {tab.title}
              </button>
            ))}
          </nav>
        </div>
        {active}
      </div>
    );
  }

  return (
    <div className={styles.Features}>
      <BounceHelmet
        title="Features"
        description="Features of the Bounce platform"
      />
      <div className={styles.HeaderBanner}>
        <div className={styles.Container}>
          <h1>
            From hosting events, to making relationships, Bounce has you
            covered.
          </h1>
          <p>
            Everything you need to host an event and more, all in one platform.
          </p>
          <ButtonPill type="ButtonWhiteWide" pb="50px" link="/dashboard">
            Get Started
          </ButtonPill>
        </div>
      </div>
      <TabGroup />
    </div>
  );
};

export default Features;
